// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:55:28

export default {
  "id": "warfront",
  "slug": "warfront",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/72cfd8c36ace4b6893390ac0e852dd57-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/72cfd8c36ace4b6893390ac0e852dd57/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Warfront",
      "description": "Warfront is a combat simulator for pro gamers inspired by CS, Standoff, and Valorant. Dive into the world of competitive FPS, testing your shooting and tactical skills across various levels. Assemble teams, improve your abilities, and upgrade your character to dominate in shooter eSports. Experience the thrill of classic CS and Valorant-style gameplay. Ready to become a counter master and a standoff legend? Prove it in Warfront!",
      "instructions": "PC:\n\nWASD: Move\nE/Q: Lean right/left\nShift: Run\nSpace: Jump\nC: Crouch\nLMB/RMB: Shoot/Aim\nR: Reload\n1-4: Change weapons\nX/Z: Switch specialization\nEsc: Menu\nTab: Score\nPhone/Tablet:\n\nLeft joystick: Move/Run (hold forward)\nButtons: Jump, crouch, reload, aim, or shoot\nArrows: Change weapons/specialization\nPause: Menu/score",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "customize",
        "explosion",
        "guns",
        "knife",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "战争前线",
      "description": "《战前线》是一款受CS、Standoff和Valorant启发的职业电竞战士模拟器。深入竞技FPS的世界，测试你的射击和战术技能，跨越各个级别。组建团队，提升你的能力，升级你的角色，成为射击电子竞技的霸主。体验经典CS和Valorant风格的游戏快感。准备好成为反恐精英和僵局传奇了吗？在《战前线》中证明你的实力！",
      "instructions": "PC:\n\nWASD: 移动\nE/Q: 向右/左倾斜\nShift: 跑步\nSpace: 跳跃\nC: 蹲下\nLMB/RMB: 射击/瞄准\nR: 重装子弹\n1-4: 更换武器\nX/Z: 切换专长\nEsc: 菜单\nTab: 分数\n手机/平板：\n\n左侧摇杆：移动/跑步（按前进键）\n按钮：跳跃、蹲下、重装、瞄准或射击\n箭头键：更换武器/专长\n暂停：菜单/分数",
      "genres": [
        "射击类游戏"
      ],
      "tags": [
        "自定义",
        "爆炸",
        "枪械",
        "刀",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "戰場前線",
      "description": "戰線是一款受CS、對峙和榮耀靈感啟發的專業遊戲家戰鬥模擬器。深入競爭性FPS的境界，在多種關卡上檢驗你的射擊和策略技巧。組織隊伍，提升你的能力，並升級你的角色以成為射手電競的霸主。體驗經典CS和榮耀風格遊戲的刺激。準備成為反恐專家和對峙傳說？在戰線中證明你的實力！",
      "instructions": "PC:\n\nWASD: 移動\nE/Q: 向右/向左傾斜\nShift: 跑步\nSpace: 跳躍\nC: 蹲下\nLMB/RMB: 射擊/對準\nR: 補充彈藥\n1-4: 切換武器\nX/Z: 切換專業技能\nEsc: 選單\nTab: 分數\n\n手機/平板：\n\n左搖桿：移動/跑步（按住前方）\n按鈕：跳躍、蹲下、補充彈藥、對準或射擊\n方向鍵：切換武器/專業技能\n暫停：選單/分數",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "自訂",
        "爆炸",
        "槍枝",
        "刀子",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "戰線",
      "description": "戰前是一款專為職業玩家設計的戰鬥模擬器，靈感來自CS、Standoff和Valorant。躍入競技FPS的世界，在多個關卡中挑戰你的射擊和戰術技巧。組隊提升能力，升級角色，成為射手電競的霸主。體驗經典CS和Valorant風格遊戲的刺激。準備成為反恐專家及對峙傳奇？在戰前證明你的實力吧！",
      "instructions": "PC:\n\nWASD：移動\nE/Q：向右/左傾斜\nShift：奔跑\n空格：跳躍\nC：蹲下\n左鍵/右鍵：射擊/擊準\nR：再裝填\n1-4：切換武器\nX/Z：切換專業技能\nEsc：選單\nTab：得分\n手機/平板：\n\n左搖桿：移動/奔跑（按住前方）\n按鈕：跳躍、蹲下、再裝填、擊準或射擊\n箭頭：切換武器/專業技能\n暫停：選單/得分",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "自訂",
        "爆炸",
        "槍械",
        "刀",
        "武器"
      ]
    },
    "ja": {
      "title": "戦域前線",
      "description": "ウォーフロントは、CS、スタンドオフ、そしてヴァロ兰特にインスパイアされたプロゲーマーのための戦闘シミュレーターです。競技FPSの世界に飛び込み、様々なレベルで射撃と戦術スキルを試してみましょう。チームを編成し、能力を向上させ、キャラクターを強化してシューティングeスポーツで支配を握ろう。古典的なCSとヴァロ兰特スタイルのゲームプレイの興奮を体験しよう。カウンターの達人であり、スタンドオフの伝説になる準備はできていますか？それをウォーフロントで証明しましょう！",
      "instructions": "PC:\n\nWASD: 移動\nE/Q: 右/左へ傾く\nShift: 走る\nSpace: 跳跃\nC: 伏せる\nLMB/RMB: 射撃/照準\nR: リロード\n1-4: 武器切り替え\nX/Z: 専門化切り替え\nEsc: メニュー\nTab: スコア\n\nPhone/Tablet:\n\n左スティック: 移動/走る（前進を押しながら）\nボタン: 跳跃、伏せる、リロード、照準、または射撃\nアローキー: 武器/専門化切り替え\n一時停止: メニュー/スコア",
      "genres": [
        "シューター"
      ],
      "tags": [
        "カスタマイズ",
        "爆発",
        "銃",
        "ナイフ",
        "武器"
      ]
    },
    "ko": {
      "title": "전쟁前沿",
      "description": "워프론트는 CS, 스탠도프, 밸러란트를 영감으로 받은 프로 게이머들을 위한 전투 시뮬레이터입니다. 경쟁型 FPS의 세계로 뛰어들어 다양한 레벨에서 쏘기와 전술 능력을 테스트하세요. 팀을 조직하고 능력을 향상시키며 캐릭터를 업그레이드하여 쏘기 e스포츠에서 지배력을 확보하세요. 클래식 CS와 밸러란트 스타일의 게임 플레이의 흥분을 경험하세요. 카운터 마스터와 스탠도프 전설이 되어보세요! 워프론에서 증명하세요!",
      "instructions": "PC:\n\nWASD: 이동\nE/Q: 오른쪽/왼쪽 기울기\nShift: 달리기\nSpace: 점프\nC: 숨기기\nLMB/RMB: 쏘기/정확도 조절\nR: 재장전\n1-4: 무기 변경\nX/Z: 전문화 변경\nEsc: 메뉴\nTab: 점수\n\n폰/태블릿:\n\n왼쪽 조이스틱: 이동/달리기(앞으로 누르기)\n버튼: 점프, 숨기기, 재장전, 정확도 조절, 쏘기\n아이콘: 무기/전문화 변경\n일시정지: 메뉴/점수",
      "genres": [
        "슈터"
      ],
      "tags": [
        "カスタマイズ",
        "爆発",
        "枪,ナイフ",
        "武器"
      ]
    },
    "fr": {
      "title": "Front de guerre",
      "description": "Warfront est un simulateur de combat pour les joueurs professionnels inspiré de CS, Standoff et Valorant. Plongez dans le monde des FPS compétitifs, testez vos compétences en tir et en stratégie sur divers niveaux. Assemblez des équipes, améliorez vos capacités et montez en grade votre personnage pour dominer les eSport de tir. Profitez du frisson du gameplay classique de CS et de Valorant. Prêt à devenir un maître de counter et une légende du standoff ? Démontrez-le dans Warfront !",
      "instructions": "PC :\n\nWASD : Se déplacer\nE/Q : Rencontrer à droite/gauche\nMaj : Courir\nEspace : Sauter\nC : Ramper\nClic gauche/droit : Tirer/Viser\nR : Recharger\n1-4 : Changer d'arme\nX/Z : Changer de spécialisation\nÉchap : Menu\nTab : Score\n\nTéléphone/Tablette :\n\nJoystick gauche : Se déplacer/Courir (tenir en avant)\nBoutons : Sauter, ramper, recharger, viser ou tirer\nFlèches : Changer d'arme/specialisation\nPause : Menu/score",
      "genres": [
        "Tirailleur"
      ],
      "tags": [
        "personnaliser",
        "explosion",
        "armes à feu",
        "couteau",
        "armes"
      ]
    }
  }
};
